import React from "react";
import propTypes from "prop-types";
import { H3, Paragraph } from "BaseComponents/Text";
import {
	HitWrapper,
	HitImageWrapper,
	HitTextWrapper,
	HitMetaDataWrapper,
	HitCategory,
} from "./StyledSearch";
import LazyBackgroundImage from "../../../framework/lazy/LazyBackgroundImage";
import { getResponsiveImage } from "Helpers/ImageHelper";

export const SearchHit = ({
	Heading,
	Url,
	DocumentType: Category,
	Description,
	ResponsiveImage,
}) => {
	let Image = getResponsiveImage(ResponsiveImage);
	return (
		<HitWrapper href={Url}>
			<HitImageWrapper>{Image && <LazyBackgroundImage source={Image} />}</HitImageWrapper>
			<HitTextWrapper>
				<HitMetaDataWrapper>
					<HitCategory>{Category}</HitCategory>
				</HitMetaDataWrapper>
				<H3 size="h3" margin="1rem 0 0 0">
					<span>{Heading}</span>
				</H3>
				<Paragraph margin="1rem 0">{Description}</Paragraph>
			</HitTextWrapper>
		</HitWrapper>
	);
};

SearchHit.propTypes = {
	Heading: propTypes.string,
	Url: propTypes.string,
	Category: propTypes.string,
	Description: propTypes.string,
	Image: propTypes.string,
};
